import { useState } from 'react'
import { Lightbox } from 'react-modal-image'

interface ImageContainerProps {
  imageUrl?: string
}

const ImageContainer = ({ imageUrl }: ImageContainerProps): JSX.Element => {
  const [imageZoom, setImageZoom] = useState(false)

  return (
    imageUrl
      ? (
        <>
          <button type='button' style={{ border: 'none', background: 'none' }} onClick={() => setImageZoom(true)}>
            <img
              style={{
                maxHeight: '90vh',
                maxWidth: '95%',
                cursor: 'pointer',
              }}
              src={imageUrl}
              alt='Lote'
            />
          </button>
          {imageZoom && (
          <Lightbox
            medium={imageUrl}
            large={imageUrl}
            onClose={() => setImageZoom(false)}
          />
          )}
        </>
      )
      : <></>
  )
}

export default ImageContainer
